"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configureQuestion = void 0;
function configureQuestion(subType) {
    return {
        answerSource: {
            dataSourceKey: "123423",
            id: 1227301,
            isFromWidget: null,
            properties: {
                answerField: "value",
                autoComplete: false,
                dataSourceId: 570751,
                detailedSearch: {
                    infiniteListSortBy: "displayOrder,value",
                },
            },
            type: "DATA_SOURCE",
        },
        formProperties: {
            id: 1227251,
            isCloneable: true,
            isRequired: false,
            isSearchable: false,
            questionRootId: 1227151,
        },
        hasDefenses: false,
        id: 1227151,
        isGlobalQuestion: false,
        lastModifiedDate: "2021-09-27T19:53:09.593813Z",
        parentWidgetRootId: null,
        parentWidgetSelectionRootId: null,
        participantRole: null,
        properties: {
            assistiveText: "will prefill all other fields in this section",
            placeHolderText: "Colors Placeholder",
        },
        rootId: 1227151,
        selections: [],
        subType: subType,
        tags: [],
        title: "Colors",
        type: "QUESTION",
        validations: [],
        workflowType: "FINAL",
    };
}
exports.configureQuestion = configureQuestion;
//# sourceMappingURL=configureQuestion.js.map